import { createActionTypes } from "../../../utils";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    ...createActionTypes("PROFILE", "GET_USER_DATA"),
  ...createActionTypes("PROFILE", "SAVE_PROFILE_EDITION"),
};
